import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=221cb00c&scoped=true&"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=221cb00c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221cb00c",
  null
  
)

export default component.exports